import $store from '@/store'

export default {
	field_types () {
		var types = {
      "checkbox": "CheckBox",
      "text": "TextField",
      "file": "FileSelect",
      "s3file": "S3FileSelect",
      "select": "ItemSelect",
      "list_select": "ListSelect",
      'key_value': "KeyValue",
      "uuid": "Uuid",
      "textarea": "TextArea",
      "markdown": "MarkDown",
      "datetime": "DateTime",
      "date": "Date",
      "multiline": "MultiLine",
      "content_select": "ContentSelect",
      "setting-select": "SettingSelect",
      "setting_select": "SettingSelect",
      "number": "Number",
      "playoff_tree": "PlayoffTree"
    }
    return types;
	},
  is_admin_access(content_list_id) {
    if ($store.getters.is_admin === true) return true;
    var groups = $store.getters.groups;
    var group = _.find(groups, (g) => {
      if (typeof(g.meta) != "undefined") {
        if (g.meta.content_admin_access === true) {
          if (g.cms_lists.includes(parseInt(content_list_id, 10))) {
            return true;
          }
        }
      }
    });
    if (typeof(group) != "undefined") return true;
    return false;
  },
  is_access(field, content_item_id, content_list_id) {
    if (field.admin_only === true) {
      return this.is_admin_access(content_list_id);
    }

    // Only admin users are allowed edit the field. Regular users are allowed to create new list items
    if (field.admin_only_edit === true) {
      if (typeof(content_item_id) === "undefined") { return true }
        return this.is_admin_access(content_list_id);
    }
    return true;
  },
  get_field_type(field_type) {
    var types = this.field_types();
    var ret = types[field_type];
 //   if (typeof(ret) == "undefined") return field_type;
    return ret;
  },
  get_path(id, {include_list = false, order = 'child-parent'} = {}) {
    if(!id) return [];
    let cms_lists = $store.state.cms_lists;
    const list = cms_lists[id];
    if (typeof(list) == "undefined") return [];
    let parent = cms_lists[list.meta.parent_list_id];

    let path = [];
    while (parent !== undefined) {
      path.push(parent.id);
      parent = cms_lists[parent.meta.parent_list_id];
    };

    if(include_list) { path.push(id) };
    if(order == 'parent-child') path.reverse();
    return path;
  }
}
